import React, { useState } from 'react'
import { Box, Button } from '@mui/material'
import asset from "json/assets";

import styles from '../../styles/component/SideBar.module.scss'


const SideBarActions = ({ toggleSideBar, onSaveClick, onCancelClick, form }) => {
  const [open, setOpen] = useState(false);
  
  const toggleOpen = () => {
    toggleSideBar();
    setOpen(prev => !prev)
  };

  return (
    <Box>
      <div
        className={
          open
            ? `${styles.sidebar_list}`
            : `${styles.sidebar_list} ${styles.sidebar_list_open}`
        }
      >
        <ul>
          <li>
            <Button onClick={onCancelClick}>
              <span className={styles.icon}>
                <img src={asset.listIconL} alt="" />
              </span>
              {/* <span style={open ? {width: "100%",opacity :"1"} : {width : "0",opacity:"0"}}>Course Map</span> */}
              <span
                className={
                  open ? `${styles.expand_span}` : `${styles.shrink_span}`
                }
              >
                Back To list
              </span>
            </Button>
          </li>
          <li>
            <Button onClick={onSaveClick} form={form} type={form ? 'submit' : 'button'} >
              <span className={styles.icon}>
                <img src={asset.saveIcon} alt="" />
              </span>
              <span
                className={
                  open ? `${styles.expand_span}` : `${styles.shrink_span}`
                }
              >
                Save
              </span>
              {/* <span style={open ? {width: "100%",opacity :"1"} : {width : "0",opacity:"0"}}>Assets</span> */}
            </Button>
          </li>
        </ul>
        <Button className={styles.open_drawer} onClick={toggleOpen}>
          <img src={asset.right_arrow} alt="" />
        </Button>
      </div>
    </Box>
  )
}

export default SideBarActions